'use client';
import { FilpCarousel } from '@/components/atoms/Carousel';
import CarosuelItem from './CarosuelItem';
import { QuotesCodeMapping } from '@/constants/quote/quote';
import { getForexLists } from './getForexLists';
import { useQuery } from '@tanstack/react-query';

type Quotes = {
  [QuotesCodeMapping.SYMBOL]: string;
  [QuotesCodeMapping.CHINESE_NAME]: string;
  [QuotesCodeMapping.ENGLISH_NAME]: string;
  [QuotesCodeMapping.CLOSE]: string;
  [QuotesCodeMapping.CHANGE_V2]: string;
  [QuotesCodeMapping.CHANGE_PERCENT_V2]: string;
};

const Empty = () => (
  <div className='flex h-10 w-full items-center gap-4 rounded-lg bg-[#383838] px-2 py-[5px] text-sm text-white'></div>
);

const FilpForexCarouselClient = () => {
  const { data } = useQuery({
    queryKey: ['forex-index-carousel'],
    queryFn: getForexLists,
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    placeholderData: prev => prev
  });

  if (!data || data?.length === 0) return <Empty />;

  return (
    <div className='w-full'>
      <FilpCarousel speed={5000} style='h-[40px]'>
        {data.map((item: Quotes) => (
          <CarosuelItem data={item} key={item[QuotesCodeMapping.SYMBOL]} />
        ))}
      </FilpCarousel>
    </div>
  );
};

export default FilpForexCarouselClient;
